import React from 'react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText, EditableImage } from '../../components';

function PtaGallery({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const pta = data.pta || {};
  const gallery = data.gallery || {};
  const updatePta = (patch) => update({ pta: { ...pta, ...patch } });
  const updateGallery = (patch) => update({ gallery: { ...gallery, ...patch } });
  const bullets = pta.bullets || [];
  const updateBullet = (i, t) => {
    const next = [...bullets];
    next[i] = t;
    updatePta({ bullets: next });
  };
  const gItems = gallery.items || [];
  const updateGItem = (i, patch) => {
    const next = gItems.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    updateGallery({ items: next });
  };
  return (
    <section className="py-24 bg-olive-light">
      <div className="container-page grid lg:grid-cols-2 gap-8">
        <Reveal>
          <div className="card-surface p-8 h-full">
            <EditableText value={pta.heading} onChange={(t) => updatePta({ heading: t })} as="h3" className="font-display text-2xl" />
            <EditableText value={pta.body} onChange={(t) => updatePta({ body: t })} as="p" multiline className="mt-4 text-ink/70 leading-relaxed" />
            <ul className="mt-6 space-y-2.5 text-sm text-ink/70">
              {bullets.map((b, i) => <li key={i}>• <EditableText value={b} onChange={(t) => updateBullet(i, t)} as="span" /></li>)}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="card-surface p-8 h-full">
            <EditableText value={gallery.heading} onChange={(t) => updateGallery({ heading: t })} as="h3" className="font-display text-2xl" />
            <div className="mt-6 grid grid-cols-3 gap-3">
              {gItems.map((g, i) => (
                <div key={i} className="relative group rounded-2xl overflow-hidden aspect-square">
                  <EditableImage
                    src={g.image?.src}
                    alt={g.image?.alt || g.caption}
                    onChange={(src, alt) => updateGItem(i, { image: { src, alt } })}
                    className="h-full w-full object-cover transition-transform group-hover:scale-110"
                  />
                  <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-olive-footer/90 to-transparent p-2">
                    <EditableText value={g.caption} onChange={(t) => updateGItem(i, { caption: t })} as="span" className="text-white text-[10px] font-medium" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default PtaGallery;
